import { Divider, Typography } from '@mui/material';
import React from 'react';
import { MintCountdown } from './MintCountdown';
import './MintDetails.css';

const enum COUNTDOWN_STATUS {
  INCOMING = 'INCOMING',
  LIVE = 'LIVE',
  ENDED = 'ENDED',
}

export default function MintDetails() {

  // EST time === UTC-5
  // const eggDate = new Date(Date.UTC(2023,1,24,9,0,0,0));
  // const holdersDate = new Date(Date.UTC(2023,1,24,18,0,0,0));
  // const daoDate = new Date(Date.UTC(2023,1,24,19,0,0,0));
  // const publicDate = new Date(Date.UTC(2023,1,24,19,30,0,0));
  // const eggDateTake2 = new Date(Date.UTC(2023,2,2,5,0,0,0));
  // const nastyDate = new Date(Date.UTC(2023,2,4,5,0,0,0));
  const publicDate2 = new Date(Date.UTC(2023,2,6,5,0,0,0));

  // 1 year
  const endMintDate = new Date(Date.UTC(2024,2,21,19,0,0,0));


  const getStatus = (initDate: Date, endDate: Date) => {
    const now = Date.now();
    const init = initDate.getTime();
    const end = endDate.getTime();
    if (now < init) {
      return COUNTDOWN_STATUS.INCOMING;
    }

    if (now > init && now < end) {
      return COUNTDOWN_STATUS.LIVE;
    }

    return COUNTDOWN_STATUS.ENDED;
  }

  const phaseCountDown = (initDate: Date, endDate: Date) => {

    const status = getStatus(initDate, endDate);

    const color = status == COUNTDOWN_STATUS.LIVE ? 'green' : 'red';
    return <MintCountdown
              date={initDate}
              style={{ justifyContent: "center", alignItems: "center", backgroundColor: '#363636', borderRadius: 4 }}
              styleStatus={{ backgroundColor: color, fontSize: 18, padding: "0px 6px" }}
              status={status}
            />
  }

  return (
    <div>
      {/* <div className='phase-container'>
        <div className='phase-content'>
          <Typography variant='body2'>Phase 1: Egg holders</Typography>
          <Typography variant='body2' sx={{opacity:0.5, marginTop: -1}}>6:00am EST / Free</Typography>
        </div>

        {phaseCountDown(eggDate, holdersDate)}
      </div>
      <Divider sx={{marginTop: 1, marginBottom: 1}}/>
      <div className='phase-container'>
        <div className='phase-content'>
          <Typography variant='body2'>Phase 2: Gooney Toon holders</Typography>
          <Typography variant='body2' sx={{opacity:0.5, marginTop: -1}}>1:00pm EST / 1.6 SOL</Typography>
        </div>

        {phaseCountDown(holdersDate, daoDate)}
      </div>
      <Divider sx={{marginTop: 1, marginBottom: 1}}/>
      <div className='phase-container'>
        <div className='phase-content'>
          <Typography variant='body2'>Phase 3: DAO & project collabs</Typography>
          <Typography variant='body2' sx={{opacity:0.5, marginTop: -1}}>2:00pm EST / 1.9 SOL</Typography>
        </div>

        {phaseCountDown(daoDate, publicDate)}
      </div>
      <Divider sx={{marginTop: 1, marginBottom: 1}}/> */}
      {/* <div className='phase-container'>
        <div className='phase-content'>
          <Typography variant='body2'>Phase 4: Public</Typography>
          <Typography variant='body2' sx={{opacity:0.5, marginTop: -1}}>2:30pm EST / 1.9 SOL</Typography>
        </div>

        {phaseCountDown(publicDate, eggDateTake2)}
      </div>
      <Divider sx={{marginTop: 1, marginBottom: 1}}/>
      <div className='phase-container'>
        <div className='phase-content'>
          <Typography variant='body2'>Phase 5: Egg holders</Typography>
          <Typography variant='body2' sx={{opacity:0.5, marginTop: -1}}>March 2nd, 0:00 EST / FREE</Typography>
        </div>

        {phaseCountDown(eggDateTake2, nastyDate)}
      </div>
      <Divider sx={{marginTop: 1, marginBottom: 1}}/>
      <div className='phase-container'>
        <div className='phase-content'>
          <Typography variant='body2'>Phase 6: Nasty mint</Typography>
          <Typography variant='body2' sx={{opacity:0.5, marginTop: -1}}>March 4th, 0:00 EST / 5k $Nasty</Typography>
        </div>

        {phaseCountDown(nastyDate, publicDate2)}
      </div>
      <Divider sx={{marginTop: 1, marginBottom: 1}}/> */}
      <div className='phase-container'>
        <div className='phase-content'>
          <Typography variant='body2'>Public Mint</Typography>
          <Typography variant='body2' sx={{opacity:0.5, marginTop: -1}}>March 6th, 0:00 EST / 2.5 SOL</Typography>
        </div>

        {phaseCountDown(publicDate2, endMintDate)}
      </div>
      <Divider sx={{marginTop: 1, marginBottom: 1}}/>
    </div>
  )
}
